import type { Template } from "@/types";

export const PO_04_H4_V0: Template[] = [
    {
        id: "hs-04-h4v0-01",
        name: "PO 01 - H4V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_01.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 174, y: 109, width: 478, height: 297, rotation: 0, imageRotation: 0 },
            { id: "2", x: 174, y: 414, width: 478, height: 297, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 109, width: 477, height: 297, rotation: 0, imageRotation: 0 },
            { id: "4", x: 660, y: 414, width: 477, height: 297, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-02",
        name: "PO 02 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_02.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 84, y: 102, width: 489, height: 305, rotation: 0, imageRotation: 0 },
            { id: "2", x: 84, y: 415, width: 489, height: 304, rotation: 0, imageRotation: 0 },
            { id: "3", x: 738, y: 102, width: 489, height: 305, rotation: 0, imageRotation: 0 },
            { id: "4", x: 738, y: 415, width: 489, height: 304, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-03",
        name: "PO 03 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_03.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 298, width: 323, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 331, y: 298, width: 322, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 661, y: 298, width: 322, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 991, y: 298, width: 322, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-04",
        name: "PO 04 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_04.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 0, y: 504, width: 322, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 330, y: 504, width: 322, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 660, y: 504, width: 322, height: 224, rotation: 0, imageRotation: 0 },
            { id: "4", x: 990, y: 504, width: 321, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-05",
        name: "PO 05 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_05.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 55, y: 66, width: 547, height: 341, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 415, width: 547, height: 341, rotation: 0, imageRotation: 0 },
            { id: "3", x: 710, y: 66, width: 547, height: 341, rotation: 0, imageRotation: 0 },
            { id: "4", x: 710, y: 415, width: 547, height: 341, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-06",
        name: "PO 06 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_06.png",
        size: [1252, 783],
        style: {},
        slots: [          
            { id: "1", x: 63, y: 70, width: 350, height: 222, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 300, width: 350, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 63, y: 530, width: 350, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 717, y: 244, width: 532, height: 331, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-07",
        name: "PO 07 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_07.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 66, y: 187, width: 524, height: 447, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 187, width: 532, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 717, y: 496, width: 263, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 988, y: 496, width: 262, height: 138, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-08",
        name: "PO 08 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_08.png",
        size: [1252, 783],
        style: {},
        slots: [          
            { id: "1", x: 72, y: 89, width: 330, height: 210, rotation: 0, imageRotation: 0 },
            { id: "2", x: 72, y: 307, width: 330, height: 210, rotation: 0, imageRotation: 0 },
            { id: "3", x: 72, y: 525, width: 330, height: 209, rotation: 0, imageRotation: 0 },
            { id: "4", x: 410, y: 89, width: 828, height: 644, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-09",
        name: "PO 09 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_09.png",
        size: [1252, 783],
        style: {},
        slots: [          
            { id: "1", x: 127, y: 152, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "2", x: 127, y: 327, width: 259, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 127, y: 502, width: 259, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 394, y: 152, width: 791, height: 516, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-10",
        name: "PO 10 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_10.png",
        size: [1252, 783],
        style: {},
        slots: [
            { id: "1", x: 34, y: 31, width: 602, height: 376, rotation: 0, imageRotation: 0 },
            { id: "2", x: 34, y: 415, width: 602, height: 376, rotation: 0, imageRotation: 0 },
            { id: "3", x: 676, y: 31, width: 602, height: 376, rotation: 0, imageRotation: 0 },
            { id: "4", x: 676, y: 415, width: 602, height: 376, rotation: 0, imageRotation: 0 }
        ],
    }
];